import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import moment from "moment";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import PreviewIcon from "@mui/icons-material/Preview";
import DeleteIcon from "@mui/icons-material/Delete";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../../global";
import HelpIcon from "@mui/icons-material/Help";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {
  TextField,
  Toolbar,
  Autocomplete,
  Grid,
  useMediaQuery,
  Modal,
  Checkbox,
  Typography,
} from "@mui/material";
import ExcelDownload from "../../../utils/components/excelDownload";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import axiosWithToken from "../../../utils/components/axiosTokenConfig";
import ErrorModal from "../../../utils/components/errorModal";
import ListWrap from "../../commonComponent/listWrap";
import { accuracyFormat, parseRange } from "../../../utils/components/accuracyandlcandrangesshow";
import { paginationrowsPerPageOptions } from "../../../constants/commonConst";
import { StandardImportExcelModal } from "./standardImportExcelModal";

// datatablse packages
var $ = require("jquery");
$.DataTable = require("datatables.net");


const EQUIPMENT_TYPE={
  1: "Master",
  2: "Supportive",
}

const columns = [
  { id: "id", label: "Sr. No." },
  { id: "dName", label: "Disipline" },
  { id: "stIds", label: "Id", minWidth: 40 },
  { id: "serialNo", label: "Serial Number", minWidth: 40 },
  { id: "standardName", label: "Master EQP Name", minWidth: 40 },
  { id: "make", label: "Make", minWidth: 40 },
  { id: "model", label: "Model", minWidth: 40 },
  {
    id: "certificateNumber",
    label: "Tracability",
    align: "left",
    minWidth: 40,
  },
  {
    id: "traceability",
    label: "Cal Agency",
    align: "left",
    minWidth: 40,
  },
  {
    id: "type",
    label: "Type",
    align: "left",
    minWidth: 60,
  },
  {
    id: "calDate",
    label: "Cal.Date",
    minWidth: 40,
    align: "left",
    format: (value) => moment(value).format("DD-MM-YYYY"),
  },
  {
    id: "validUpto",
    label: "Due Date",
    minWidth: 40,
    align: "left",
    format: (value) => moment(value).format("DD-MM-YYYY"),
  },
];
const notNeededColumn = ["id", "status", "type"];
export default function StandardsList(props) {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const urlPath = useLocation();
  const [page, setPage] = React.useState(() => Number(sessionStorage.getItem("ListPageCount") || 0));
  const [rowsPerPage, setRowsPerPage] = React.useState(() => Number(sessionStorage.getItem("ListRowsPerPage") || 30));
  const [standardList, setStandardList] = React.useState([]);
  const [searchBy, setSearchBy] = React.useState(sessionStorage.getItem("searchBy") || "Master Id");
  const [searchKey, setSearchKey] = React.useState(sessionStorage.getItem("searchKey") || "");
  const [from, setFrom] = React.useState(null);
  const [finalData, setFinalData] = React.useState([]);
  const [filterModalOpen, setFilterModalOpen] = React.useState(false);
  const [to, setTo] = React.useState(null);
  const [totalRows, setTotalRows] = React.useState(0);
  const [errormodalIsOpen, setErrorModalIsOpen] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(null);
  const [searched, setSearched] = React.useState(sessionStorage.getItem("searched") === "true");
  const [editAccess, setEditAccess] = React.useState(localStorage.getItem("editAccess")?.split(",").map(Number));
  const userType = localStorage.getItem("type");
  const [rejectModalOpen, setRejectModalOpen] = React.useState(false);
  const [rejectReason, setRejectReason] = React.useState("");
  const [rejectId, setRejectId] = React.useState(null);
  const navigate = useNavigate();
  const [selected, setSelected] = React.useState([]);  
  let disbledPrintEnginner = props.isCount == true && userType == 2;
  const handleSelectRow = (id) => {
    setSelected((prev) => {
      if (prev.includes(id)) {
        return prev.filter((item) => item !== id);
      } else {
        return [...prev, id];
      }
    });
  };
  const isSelected = (id) => selected.includes(id);
  const openErrorModal = (errorMessage,stackTrace,fileName) => {
    setErrorMessage({ errorMessage, stackTrace, fileName });
    setErrorModalIsOpen(true);
  };
  const closeErrorModal = () => {
    setErrorModalIsOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    sessionStorage.setItem("currentPath", urlPath.pathname);
    sessionStorage.setItem("ListPageCount", newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    sessionStorage.setItem("ListRowsPerPage", event.target.value);
    sessionStorage.setItem("ListPageCount", 0);
  };
  const handleFilterOpen = () => setFilterModalOpen(true);
  const handleFilterClose = () => setFilterModalOpen(false);

  const submitSiteDelete = (id) => {
    const idString = (Array.isArray(id) ? id : [id]).join(',');
    let standardsQuery = {
      query: `UPDATE standards SET status = -1 WHERE id IN (${idString});`
    }; 
    let standardRangesQuery = {
      query: `UPDATE standardRanges SET status = -1 WHERE standardId IN (${idString});`
    };
    let url = BASE_URL;
    axiosWithToken
      .post(url + `dynamic`, standardsQuery)
      .then(() => {
        return axiosWithToken.post(url + `dynamic`, standardRangesQuery);
      })    
      .then((res) => {
        toast("Master EQP deleted successfully!");
        setTimeout(refresh, 500);
      })
      .catch((error) => console.log("err", error));
  };

  const [showRejectInput, setShowRejectInput] = React.useState(false);
  const [usersArray, setUsersArray] = React.useState([]);
  const userID = localStorage.getItem("id");
  const openActionModal = (row) => {
    setRejectId(row.id);
    setShowRejectInput(false);
    setRejectReason("");
    setRejectModalOpen(true);
  };
  const getUserList = () => {
    let url = BASE_URL;
    axiosWithToken
      .get(url + "users?_where=(status,eq,1)")
      .then((res) => {
        setUsersArray(res.data);
      })
      .catch(err => console.log(err));
  };

  const approveStandard = (id) => {
    const idString = (Array.isArray(id) ? id : [id]).join(',');
    axiosWithToken
      .post(BASE_URL + "dynamic", {
        query: `UPDATE standards SET approvedBy = ${userID} WHERE id IN (${idString})`
      })
      .then(() => {
        toast.success("Master EQP approved");
        setTimeout(refresh, 500);
      })
      .catch(err => console.log(err));
  };
  const rejectStandard = () => {
    if (!rejectReason.trim()) {
      toast.error("Please enter reject reason");
      return;
    }
    axiosWithToken
      .post(BASE_URL + "dynamic", {
        query: `UPDATE standards SET rejectedBy = ${userID}, rejectedReason = '${rejectReason}'WHERE id = ${rejectId}`
      })
      .then((res) => {
        toast.success("Master EQP rejected");
        setRejectModalOpen(false);
        setRejectReason("");
        setTimeout(refresh, 500);
      })
      .catch(err => console.log(err));
  };

  var refresh = () => {
    window.location.reload(false);
  };

  const getQuery = (count = false, removePagination = false) => {
    let whereConditions = "";
    let pagination_settings = "";

    if (searchBy !== "" && searchKey != "") {
      let colName = {
        Disipline: "disc.name",
        "Master Id": "standard.stId",
        "Master EQP Name": "standard.standardName",
        Tracability: "standard.certificateNumber",
        "Serial No": "standard.serialNo",
        Type: "standard.type",
        Due: "standard.validUpto",
      }[searchBy];

      whereConditions = `where LOWER(${colName}) like LOWER('%${searchKey}%')`;
    }

    if (to != null && from != null) {
      if (whereConditions === "") {
        whereConditions = " where ";
      } else {
        whereConditions += " and ";
      }
      whereConditions += ` standard.validUpto between '${moment(from).format(
        "YYYY-MM-DD"
      )}' and '${moment(to).format("YYYY-MM-DD")}'`;
    }
    if (whereConditions == "") {
      whereConditions += " where standard.status != -1  ";
    } else {
      whereConditions += " and standard.status != -1  ";
    }

    if (searchBy === "Due") {
      whereConditions += " and validUpto < CURDATE()";
    }

    if (["Approved", "Unapproved"].includes(searchBy)) {
      whereConditions += whereConditions ? " and " : " where ";
      whereConditions +=
        searchBy === "Approved"
          ? "(standard.approvedBy IS NOT NULL AND standard.approvedBy != 0)"
          : "(standard.approvedBy IS NULL OR standard.approvedBy = 0)";
    }    

    if(props.isCount == true){
      whereConditions +=
      whereConditions.length > 0
        ? ` and validUpto is NOT NULL and validUpto <= CURDATE() + INTERVAL 20 DAY and standard.status != -1 and standard.renewalStatus = 1`
        : `where validUpto is NOT NULL and validUpto <= CURDATE() + INTERVAL 20 DAY and standard.status != -1 and standard.renewalStatus = 1`;
    }

    if (!removePagination && rowsPerPage != -1) {
      pagination_settings = `limit ${rowsPerPage} offset ${
        rowsPerPage * Number(page)
      }`;
    }
    let data = {
      query: `select disc.name as dName, standard.stId as stIds,standard.serialNo, standard.standardName,standard.make,standard.model,standard.certificateNumber,standard.traceability,standard.masterrange as ranges, standard.masterleastcount as leastcount, standard.masteraccuracy as accuracy, standard.type,standard.calDate,standard.validUpto,standard.status,standard.type,standard.id,standard.approvedBy,standard.rejectedBy,standard.rejectedReason from standards as standard left join discipline as disc on standard.disciplineId = disc.id ${whereConditions} order by standard.id DESC ${pagination_settings}`,
    };
    if (count)
      data.query = `select count(*) as no_of_rows from standards as standard left join discipline as disc on standard.disciplineId = disc.id ${whereConditions} order by standard.id DESC `;

    return data;
  };

  // api calls
  function getTotalRows() {
    let data = getQuery(true);
    axiosWithToken
    .post(BASE_URL + `dynamic`, data)
      .then(async (res) => {
        setTotalRows(res.data[0]?.no_of_rows);
      })
      .catch((err) => {
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "getTotalRows" ,"StandardsList")}><u>Error: {err.message}</u></h6>);
        }
      });
  }

    function fetchAllDataForExcel() {
      const data = getQuery(false, true);
      axiosWithToken
        .post(BASE_URL + `dynamic`, data)
        .then((res) => {
          const processed = res.data.map((item) => {
            if (item.validUpto)
              item.validUpto = moment(item.validUpto).format("DD-MM-YYYY");
            item.type = EQUIPMENT_TYPE[Number(item.type)];
            item.leastcount = parseRange(item.leastcount);
            item.ranges = parseRange(item.ranges);
            item.accuracy =accuracyFormat(item.accuracy);
            return item;
          });

          setFinalData(processed);
        })
        .catch((err) => console.log("Failed to fetch data for Excel export"));
    }

  function fetchStandards() {
    let data = getQuery();
    axiosWithToken
      .post(BASE_URL + `dynamic`, data)
      .then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].validUpto && res.data[i].validUpto !== null) {
            moment(res.data[i].validUpto).format("DD-MM-YYYY");
          }
          res.data[i].type = EQUIPMENT_TYPE[Number(res.data[i].type)];
        }
        setStandardList([...res.data]);
      })
      .catch((err) => {
        console.log("datasheet data fetching error: ", err);
        if (err.message !== "request_aborted") {
          toast.error(<h6 onClick={() => openErrorModal(err.message, "fetchStandards" ,"StandardsList")}><u>Error: {err.message}</u></h6>);
        }
      });
  }

  const copyEquipment = async (id) => {
    let instrument = await axiosWithToken
      .get(BASE_URL + `standards/${id}`)
      .then((res) => res.data[0] || []);
    delete instrument.id;
    delete instrument.lastModified;
    delete instrument.validUpto;
    delete instrument.calDate;
    delete instrument.approvedby;
    let standardRangesData = await axiosWithToken
      .get(
        BASE_URL +
          `standardRanges?_where=(standardId,eq,${id})~and(status,eq,1)`
      )
      .then((res) => res.data || []);
    axiosWithToken.post(BASE_URL + "standards", instrument).then((res) => {
      standardRangesData.map((ele) => {
        delete ele.id;
        delete ele.lastModified;
        ele.standardId = res.data.insertId;
      });
      axiosWithToken
        .post(BASE_URL + "standardRanges/bulk", standardRangesData)
        .then((res2) => setTimeout(refresh, 500));
    });
  };

  const TablePaginationActions = (props) => {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
      onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
      onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
      onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
      onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
      <Box sx={{ flexShrink: 0, ml: 2.5 }}>
        <IconButton
          onClick={handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="first page"
        >
          {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={handleBackButtonClick}
          disabled={page === 0}
          aria-label="previous page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowRight />
          ) : (
            <KeyboardArrowLeft />
          )}
        </IconButton>
        <IconButton
          onClick={handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="next page"
        >
          {theme.direction === "rtl" ? (
            <KeyboardArrowLeft />
          ) : (
            <KeyboardArrowRight />
          )}
        </IconButton>
        <IconButton
          onClick={handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="last page"
        >
          {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </Box>
    );
  };
  const storedSearchBy = sessionStorage.getItem("searched");
  useEffect(() => {
    if(storedSearchBy){
      setSearched(true);
    }
  }, [storedSearchBy]);

const search = () => {
  sessionStorage.setItem("searchBy", searchBy);
  sessionStorage.setItem("searchKey", searchKey);
  sessionStorage.setItem("searched", "true");
  sessionStorage.setItem("currentPath", urlPath.pathname);
  sessionStorage.setItem("ListPageCount", 0);
  setPage(0);
  setSearched(true);
  fetchStandards();
  getTotalRows();
};

const clearSearch = () => {
  sessionStorage.removeItem("searchBy");
  sessionStorage.removeItem("searchKey");
  sessionStorage.removeItem("searched");
  sessionStorage.removeItem("currentPath");
  sessionStorage.removeItem("ListPageCount");
  sessionStorage.removeItem("ListRowsPerPage");
  setPage(0);
  setSearchBy("Master Id");
  setSearchKey("");
  setFrom(null);
  setTo(null);
  setSearched(false);
};

  const getUserNameById = id => usersArray?.find(u => u.id == id)?.userName ?? "";
  const getCellStyle = ({ approvedBy, rejectedBy }) =>
    approvedBy || rejectedBy
      ? {
        backgroundColor: approvedBy ? "#A3F0A9" : "#F9C9C3",
        title: `${approvedBy ? "Approved" : "Rejected"} by ${getUserNameById(approvedBy || rejectedBy)
          }`
      } : {};

  const filterSection = () => (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 1.5,
        alignItems: "flex-end",
        justifyContent: "flex-start",
        py: 0.625,
      }}
    >
      <Box
        sx={{
          flex: {
            xs: "1 1 100%",
            sm: "1 1 calc(50% - 12px)",
            md: "0 0 210px",
          },
          maxWidth: {
            xs: "100%",
            sm: "none",
            md: 210,
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns} classNames="mr-2">
          <DatePicker
           className="Listinputcss"
            slotProps={{ textField: { size: "small", fullWidth: true } }}
            label="From"
            value={from ? new Date(from) : ""}
            inputFormat="dd/MM/yyyy"
            format="dd/MM/yyyy"
            onChange={(newValue) => {
              setFrom(newValue);
              setSearched(false);
            }}
            renderInput={(params) => <TextField {...params} size="small" />}
          />
        </LocalizationProvider>
      </Box>
      <Box
        sx={{
          flex: {
            xs: "1 1 100%",
            sm: "1 1 calc(50% - 12px)",
            md: "0 0 210px",
          },
          maxWidth: {
            xs: "100%",
            sm: "none",
            md: 210,
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
           className="Listinputcss"
            slotProps={{ textField: { size: "small", fullWidth: true } }}
            label="To"
            value={to ? new Date(to) : ""}
            inputFormat="dd/MM/yyyy"
            format="dd/MM/yyyy"
            onChange={(newValue) => {
              setTo(newValue);
              setSearched(false);
            }}
            renderInput={(params) => <TextField {...params} size="small" />}
          />
        </LocalizationProvider>
      </Box>
      <Box
        sx={{
          flex: {
            xs: "1 1 100%",
            sm: "1 1 calc(50% - 12px)",
            md: "0 0 210px",
          },
          maxWidth: {
            xs: "100%",
            sm: "none",
            md: 210,
          },
        }}
      >
        <Autocomplete
          sx={{
            m: 0,
            width: "100%",
          }}
           className="Listinputcss"
          size="small"
          value={searchBy}
          id="stdMastersEQPList_searchby"
          options={[
            { key: "disipline", label: "Disipline" },
            { key: "standardId", label: "Master Id" },
            { key: "standardName	", label: "Master EQP Name" },
            { key: "certificateNumber	", label: "Tracability" },
            { key: "serialNo", label: "Serial No" },
            { key: "standard.type	", label: "Type" },
            { key: "due", label: "Due" },
            { key: "approved", label: "Approved" },
            { key: "unapproved", label: "Unapproved" }
          ]}
          renderInput={(params) => <TextField {...params} label="Search By" />}
          onInputChange={(event, newInputValue) => {
            setSearchBy(newInputValue);
            setSearched(false);
          }}
        />
      </Box>
      {!["Due", "Approved", "Unapproved"].includes(searchBy) && (
      <Box
        sx={{
          flex: {
            xs: "1 1 100%",
            sm: "1 1 calc(50% - 12px)",
            md: "0 0 210px",
          },
          maxWidth: {
            xs: "100%",
            sm: "none",
            md: 210,
          },
        }}
      >
        <TextField
         className="Listinputcss"
          sx={{ width: "100%" }}
          id="stdMastersEQPList_searchbytext"
          label={"enter " + searchBy}
          size="small"
          variant="outlined"
          inputProps={{
            autoComplete: 'off',
          }}
          value={searchKey}
          onChange={(e) => {
            setSearchKey(e.target.value)
            setSearched(false);
          }}
        />
      </Box>
      )}
      <Box>
        <Button
          id="stdMastersEQPList_searchbtn"
          variant="contained"
          size="small"
          color={searched ? "error" : "primary"}
          onClick={() => {
            searched ? clearSearch() : search();
            handleFilterClose();
          }}
          disabled={disbledPrintEnginner}
        >
         {searched ? <RestartAltIcon /> : <SearchIcon />}
        </Button>
      </Box>
      {!isMobile && (
        <Box
          sx={{
            display: "flex",
            alignItems: "stretch",
            "& > div > button": {
              marginLeft: "0px !important",
            },
          }}
        >
          <ExcelDownload
            finalData={finalData}
            notNeededColumn={notNeededColumn}
          />
        </Box>
      )}
      <Box>
        <StandardImportExcelModal />
      </Box>
    </Box>
  );
  const filterModal = () => {
    return (
      <Modal open={filterModalOpen} size="md">
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "calc(100% - 30%)",
            backgroundColor: "white",
            // border: "2px solid #000",
            boxShadow: 24,
            padding: "10px",
          }}
        >
          <Button
            variant="contained"
            size="small"
            color="error"
            style={{ float: "right" }}
            onClick={handleFilterClose}
          >
            X
          </Button>
          {filterSection()}
        </Box>
      </Modal>
    );
  };

  useEffect(() => {
  if (searched == false) {
    getTotalRows();
    fetchStandards();
    fetchAllDataForExcel();
    getUserList();
  }
  if (searched) {
    setPage(sessionStorage.getItem("ListPageCount") || 0); 
  }
}, [searched]);
  
  useEffect(() => {
      getTotalRows();
    fetchStandards();
  }, [rowsPerPage, page]);

  useEffect(() => {
    if (props.isCount === true) {
      getTotalRows();
      fetchStandards();
    }
  }, [props.isCount]);

  return (
    <ListWrap>
      {filterModal()}
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Toolbar style={{ padding: "0px" }}>
          {(editAccess?.includes(0) || editAccess?.includes(9)) && (
          <Button
            id="stdMastersEQPList_createbtn"
            variant="contained"
            size="small"
            component={Link}
            to="/master/masterEQP/editStandard/0"
            disabled={disbledPrintEnginner}
          >
            <b>Create Master EQP</b>
          </Button>
          )}
        </Toolbar>
        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Button
            style={{ display: isMobile ? "block" : "none" }}
            onClick={handleFilterOpen}
          >
            <FilterAltIcon />
          </Button>
        </div>
      </div>
      {!isMobile && filterSection()}
      {selected.length > 0 && (
        <Box sx={{textAlign:"left", margin:"10px 0px", display:"flex", gap:"20px"}}>
          <Button
          variant="contained"
          size="small"
          color={"error"}
          onClick={() => {
            if (window.confirm("Really want to delete Master EQP?")){
              submitSiteDelete(selected);
            } 
          }}
          >Multiple Delete</Button>
          {selected.length > 0 && (
          <Button
          variant="contained"
          size="small"
          color={"success"}
          onClick={() => {
            if (window.confirm("Are you sure want Approve Selected Master EQP?")){
              approveStandard(selected);
            }
          }}
          >Multiple Approve</Button>
          )}
        </Box>
      )}
      <Box sx={{ width: "100%", overflow: "hidden", display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0 }}>
        <TableContainer sx={{ flex: 1, overflow: 'auto' }}>
          <Table
            stickyHeader
            aria-label="sticky table"
            size="small"
            id="stdMastersEQPList_table"
            sx={{ borderCollapse: "collapse" }}
          >
          <TableHead>
            <TableRow>
              {(editAccess?.includes(2) || editAccess?.includes(0)) && (
                <TableCell padding="checkbox">
                  <Checkbox
                    indeterminate={selected.length > 0 && selected.length < standardList.length}
                    checked={selected.length === standardList.length}
                    onChange={(event) => {
                      if (event.target.checked) {
                        setSelected(standardList.map((row) => row.id));
                      } else {
                        setSelected([]);
                      }
                    }}
                  />
            </TableCell>
              )}
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  <b>{column.label}</b>
                </TableCell>
              ))}
              <TableCell>
                <b>Actions</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {standardList?.length > 0 ? (
              standardList.map((row, index) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {(editAccess?.includes(2) || editAccess?.includes(0)) && (
                     <TableCell padding="checkbox">
                    <Checkbox
                      checked={isSelected(row.id)}
                      onChange={() => handleSelectRow(row.id)}
                    />
                  </TableCell>
                    )}
                    {columns.map((column) => {
                      let value = row[column.id];
                      if (column.id == "id") {
                        value = page * rowsPerPage + (index + 1);
                      }
                      return (
                        <TableCell key={column.id} align={column.align} style={
                            ["stIds", "standardName"].includes(column.id)
                              ? getCellStyle(row) : {}
                          }
                          title={
                            ["stIds", "standardName"].includes(column.id)
                              ? getCellStyle(row).title : ""
                          }>
                           {["stIds", "standardName"].includes(column.id) ? (
                              <Link to={`/master/masterEQP/editStandard/${row.id}`} className="custom-link" title="Edit Master EQP"
                              style={{ color: column.id == "standardName" && moment(row.validUpto).isBefore(moment().subtract(1, 'days')) ? 'red' : 'inherit', pointerEvents: disbledPrintEnginner ? 'none' : 'auto', }}>
                                {column.id === "stIds" ? value : value}
                              </Link>
                            ) : column.format ? (
                              column.format(value)
                            ) : (
                              value
                            )}
                        </TableCell>
                      );
                    })}
                    <TableCell>
                      <ButtonGroup size="small" aria-label="small button group">
                        <Tooltip title="Edit Master EQP" placement="top-start">
                          <Button
                            id="stdMastersEQPList_edit"
                            component={Link}
                            to={`/master/masterEQP/editStandard/${row.id}`}
                            disabled={disbledPrintEnginner}
                          >
                            <PreviewIcon />
                          </Button>
                        </Tooltip>
                        <Tooltip title="Copy Master EQP" placement="top-start">
                          <Button
                            id="stdMastersEQPList_copy"
                            disabled={!(editAccess?.includes(5) || editAccess?.includes(0)) || disbledPrintEnginner}
                            onClick={() => {
                              if (
                                window.confirm(
                                  "Do want to copy and create new Master EQP using selected Master EQP?"
                                )
                              ) {
                                copyEquipment(row.id);
                              }
                            }}
                          >
                            
                            <ContentCopyIcon />
                          </Button>
                        </Tooltip>
                        <Tooltip
                          title="Delete Master EQP"
                          placement="top-start"
                        >
                          <Button
                            id="stdMastersEQPList_delete"
                            disabled={!(userType == 1 || userType == 4)}
                            onClick={(e) => {
                              if (
                                window.confirm(
                                  "Really want to delete Master EQP?"
                                )
                              ) {
                                submitSiteDelete(row.id);
                              }
                            }}
                          >
                            <DeleteIcon  style={{ color:!(userType == 1 || userType == 4) ? 'lightgray' : '#dc3545' }} />
                          </Button>
                        </Tooltip>
                         <Tooltip
                          title="Approve/Reject Master EQP"
                          placement="top-start"
                        >
                        <Button onClick={() => openActionModal(row)}>
                          <CheckCircleIcon />
                        </Button>
                        </Tooltip>
                      </ButtonGroup>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center">
                 <h6><b>Data Not Found</b></h6>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={paginationrowsPerPageOptions}
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        component="div"
        colSpan={3}
        SelectProps={{
          inputProps: {
            "aria-label": "rows per page",
          },
          native: true,
        }}
        ActionsComponent={TablePaginationActions}
      />
    </Box>
      <ToastContainer />
      {errormodalIsOpen && <ErrorModal errormodalIsOpen={errormodalIsOpen} closeErrorModal={closeErrorModal} errorMessage={errorMessage} />}
      <Modal open={rejectModalOpen} onClose={() => setRejectModalOpen(false)}>
        <Box sx={{
          position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)",
          width: 420, bgcolor: "background.paper", p: 2.5, boxShadow: 24, borderRadius: 2
        }}>

          {(() => {
            const r = standardList.find(x => x.id === rejectId);
            if (!r) return null;

            const user = id => usersArray?.find(u => u.id == id)?.userName || "";
            const box = (bg, c, t) => (
              <Box sx={{ bgcolor: bg, color: c, p: 1.5, borderRadius: 1, fontWeight: 600, mt: 1 }}>
                {t}
              </Box>
            );

            return (
              <>
                <Typography variant="h6">Master EQP Name : {r.standardName}</Typography>

                {r.approvedBy != 0 && box("#e8f5e9", "#2e7d32", `Approved by ${user(r.approvedBy)}`)}

                {r.rejectedBy != 0 && (
                  <>
                    {box("#fdecea", "#c62828", `Rejected by ${user(r.rejectedBy)}`)}
                    <Typography fontSize={17} sx={{mt:1}}><b>Reason:</b> {r.rejectedReason}</Typography>
                  </>
                )}

                {!r.approvedBy && !r.rejectedBy && (
                  <>
                    {showRejectInput && (
                      <TextField fullWidth multiline rows={3} label="Reject Reason"
                        value={rejectReason} onChange={e => setRejectReason(e.target.value)} sx={{ mt: 1 }} />
                    )}

                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 2 }}>
                      <Button variant="contained" color="success"
                        onClick={() => window.confirm(`Approve ${r.standardName}?`) && approveStandard(r.id)}>
                        Approve
                      </Button>
                      <Button variant="contained" color="error"
                        onClick={() => showRejectInput ? rejectStandard() : setShowRejectInput(true)}>
                        Reject
                      </Button>
                    </Box>
                  </>
                )}
              </>
            );
          })()}
        </Box>
      </Modal>

    </ListWrap>
  );
}
